import axios from "axios";

const aws='https://s9lisn1w1b.execute-api.ap-south-1.amazonaws.com/default'

export const fetchConnectedDevices = async (data) => {
    try {
      const response = await axios.post(
        `${aws}/house/devices`,
        data,
      );
      if(response.data.success){
      return response.data.data.devices;
      }else{
        return []
      }
    } catch (error) {
      return []
    }
  };

  export const fetchMutipleHouseConnectedDevices = async (data) => {
    try {
      const response = await axios.post(
        `${aws}/house/multi`,
        data,
      );
      if(response.data.success){
      return response.data.data.devices;
      }else{
        return []
      }
    } catch (error) {
      return []
    }
  };